import { API_FACTORY } from '@connect-x-app/shared-utils';

export enum FlightRoomOption {
  AIRCRAFT = 'aircraft',
  ATC_CALL_SIGN = 'atcCallSign',
  DEPARTURE_AIRPORT_IATA = 'departure.airport.iata',
  DEPARTURE_AIRPORT_ICAO = 'departure.airport.icao',
  DEPARTURE_GATE = 'departure.gate',
  DESK = 'desk',
  DESTINATION_AIRPORT_IATA = 'destination.airport.iata',
  DESTINATION_AIRPORT_ICAO = 'destination.airport.icao',
  DESTINATION_GATE = 'destination.gate',
  FLIGHT_NUMBER = 'flightNumber',
}

export const getFlightRoomOptionsURL = (optionName: FlightRoomOption): string => API_FACTORY.v2(`rooms/${optionName}`);
